module.exports = __webpack_public_path__ + "img/制御工学8_6.0d330ad0.png";